module.exports = __webpack_public_path__ + "media/advantage/oneStop-863e606b.jpg";